import { BellFilled, MailOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { Badge, Button, Drawer, Flex, Image, Layout, List, Typography } from "antd";
import { useEffect, useState } from "react";
import { getComments, getOrders } from "../../API";
import digiconnex from '../../assets/images/digiconnex.jpg'
import { Link } from "react-router-dom";

function AppHeader() {
  const [comments, setComments] = useState([]);
  const [orders, setOrders] = useState([]);
  const [commentsOpen, setCommentsOpen] = useState(false);
  const [notificationsOpen, setNotificationsOpen] = useState(false);

  // useEffect(() => {
  //   getComments().then((res) => {
  //     setComments(res.comments);
  //   });
  //   getOrders().then((res) => {
  //     setOrders(res.products);
  //   });
  // }, []);

  const handleHelp = () => {
    const link = document.createElement('a');
    link.href = './Tài-liệu-hướng-dẫn-zalo-portal.html';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return (
    <Layout.Header className="AppHeader">
        <Image width={150} src={digiconnex} preview={false}></Image>
      {/* <Flex align="baseline" justify="space-between" gap={5}>
        <Badge count={comments.length} dot styles={{ root: {fontSize: 24, cursor: 'pointer'} }} onClick={() => {setCommentsOpen(true);}}>
          <MailOutlined/>
        </Badge>
        <Badge count={orders.length} offset={[-1,2]} styles={{ root: {fontSize: 24, cursor: 'pointer'}}} onClick={() => {setNotificationsOpen(true);}}>
          <BellFilled/>
        </Badge>
      </Flex>
      <Drawer
        title="Comments"
        open={commentsOpen}
        onClose={() => {
          setCommentsOpen(false);
        }}
        maskClosable
      >
        <List
          dataSource={comments}
          renderItem={(item) => {
            return <List.Item>{item.body}</List.Item>;
          }}
        ></List>
      </Drawer>
      <Drawer
        title="Notifications"
        open={notificationsOpen}
        onClose={() => {
          setNotificationsOpen(false);
        }}
        maskClosable
      >
        <List
          dataSource={orders}
          renderItem={(item) => {
            return (
              <List.Item>
                <Typography.Text strong>{item.title}</Typography.Text> has been
                ordered!
              </List.Item>
            );
          }}
        ></List>
      </Drawer> */}
      <Button type="text" onClick={handleHelp} icon={<QuestionCircleOutlined  style={{fontSize: 20}}/>} iconPosition="end">
        Help
      </Button>
    </Layout.Header>
  );
}
export default AppHeader;
